<div class="loader-wrapper" *ngIf="paging.loading || paging.total === 0">
  <div class="loader" *ngIf="paging.loading">
    <div class="content">
      <div>
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      </div>
      <div class="p-2 ml-3">
        <h3>Loading...</h3>
        <div>{{paging.loadingMessage}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="!paging.loading && paging.total === 0" class="no-results text-muted text-center">
    <p>The server returned no results.</p>
  </div>
</div>
